import { render, staticRenderFns } from "./reportCard.vue?vue&type=template&id=3189f646&scoped=true&"
import script from "./reportCard.vue?vue&type=script&lang=js&"
export * from "./reportCard.vue?vue&type=script&lang=js&"
import style0 from "./reportCard.vue?vue&type=style&index=0&id=3189f646&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189f646",
  null
  
)

export default component.exports